import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { class: "main-layout__header" }
const _hoisted_3 = { class: "main-layout__content" }

import {API_URL} from "@/resourses/api";

import {computed, onMounted, ref, watch} from "vue";
import router from "@/router";
import {Moon, Sunny, UserFilled} from "@element-plus/icons-vue";
import { useDark, } from '@vueuse/core'


export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const isDark = useDark({selector: 'html',})

const user = ref({
  username: null
})

const isAlert = ref(false)
watch(isAlert,()=>{
  localStorage.setItem('isAlert', isAlert.value.toString())
})
onMounted(()=>{
  isAlert.value = JSON.parse(localStorage.getItem('isAlert') || 'false')
})

const activeIndex = computed(()=>router.currentRoute.value.path)
watch(activeIndex,()=>{
  getMe(activeIndex.value)
})
const getMe = (index: string)=>{
  if(index !== '/'){
    let service = index
    fetch(`${API_URL}${service}/users/me`,{
      credentials: 'include'
    })
        .then(response=>{
          response.json()
              .then(result=>{
                console.log(result)
                if(result.status !== 401 && result.status !== 403 && !result.detail) user.value.username = result.username
                else {
                  window.location.href = `${API_URL}${service}/users/login`
                }
              })
        })
        .catch(error=>{
          console.error(error)
        })
  }
}
const logout = ()=>{
  router.push('/login')

  fetch(`${API_URL}/builder/users/logout`,{
    credentials: 'include'
  }).then(response=>{
    console.log(response)
  }).catch(error=>{console.error(error)})
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        class: "el-menu-demo",
        mode: "horizontal",
        ellipsis: false,
        router: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, { index: "/" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Билдер", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/toggles" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Тогглы", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/logs" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Логи", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/notifications" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Уведомления", -1)
            ]))]),
            _: 1
          }),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-grow" }, null, -1)),
          _createVNode(_component_el_menu_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown, null, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      (user.value?.username)
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(user.value.username), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _unref(isDark),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isDark) ? (isDark).value = $event : null)),
                            "active-icon": _unref(Moon),
                            "inactive-icon": _unref(Sunny),
                            "inline-prompt": "",
                            style: {"--el-switch-off-color":"var(--el-color-warning)"}
                          }, null, 8, ["modelValue", "active-icon", "inactive-icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox, {
                            modelValue: isAlert.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isAlert).value = $event)),
                            label: "Уведомлять о завершении билда",
                            size: "large"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_dropdown_item, {
                        divided: "",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (logout()))
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("Выйти", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    circle: "",
                    type: "primary"
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_el_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(UserFilled))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["default-active"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})